"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBadge = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new badge.
 *
 * ## Usage
 *
 * ```ts
 * const badge: Omit<Badge, '_id'> = {
 *   name: "New Badge",
 *   description: "Very cool new badge.",
 *   requirements: "video",
 *   img: "http://http.cat/404.jpg",
 *   points: 5,
 *   gameId: 25413,
 *   title: null,
 *   isSteamGame: true,
 *   enabled: true,
 *   legacy: false,
 * };
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createBadge({ badge });
 * ```
 *
 * @param params.badge - Data of the new badge. All fields of the type Badge are required.
 */
const createBadge = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { badge } = params;
    const url = `${BASE_URL}/badges`;
    const badgeResponse = yield axios_1.default.post(url, badge, { validateStatus: () => true });
    const { status, data } = badgeResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createBadge = createBadge;
